import { Account } from '@treasury/domain/dashboard';
import { formatUsdCurrency } from '@treasury/utils';

export class AccountViewModel {
    constructor(private readonly account: Account) {}

    public get currentBalanceFormatted() {
        return formatUsdCurrency(this.currentBalance);
    }

    public get currentBalance() {
        return this.account.currentBalance || 0;
    }

    public get availableBalanceFormatted() {
        return formatUsdCurrency(this.availableBalance);
    }

    public get availableBalance() {
        return this.account.availableBalance || 0;
    }

    public get collectedBalanceFormatted() {
        return formatUsdCurrency(this.collectedBalance);
    }

    public get visibleBalance() {
        return this.account.type === 'Loan' || this.account.type === 'Time Deposit'
            ? this.currentBalanceFormatted
            : this.availableBalanceFormatted;
    }

    public get visibleBalanceLabel() {
        return this.account.type === 'Loan' || this.account.type === 'Time Deposit'
            ? 'Current'
            : 'Available';
    }

    public get collectedBalance() {
        return this.account.collectedBalance || 0;
    }

    public get name() {
        return this.account.name;
    }

    public get number() {
        return this.account.number;
    }

    public get type() {
        return this.account.type;
    }

    public get id() {
        return this.account.toDto().id;
    }
}
